/* global localize */
import React, { useContext, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useHistory } from 'react-router-dom';
import { SurveyContext } from '../context/surveyContext';

export default function Questions() {
  const {
    survey,
    setSurvey,
    questionList,
    setQuestionList,
    result,
    setResult,
    setShowActive,
  } = useContext(SurveyContext);

  const history = useHistory();

  const [currentQuestion, setCurrentQuestion] = useState(0);

  function onChange(event) {
    setResult({
      ...result,
      [event.target.name]: event.target.value,
    });
  }

  function onsubmit() {
    survey.questions.forEach((question, index) => {
      if (index === currentQuestion) {
        survey.questions[currentQuestion].answer =
          result[`answer_${currentQuestion}`];
      }
    });

    setSurvey({
      ...survey,
      questions: survey.questions,
    });
    handelNextQuestion();
    createQuestionList();
  }

  const createQuestionList = () => {
    let questions = [];

    survey &&
      survey.questions.forEach((question) => {
        questions.push({
          questionText: question.question,
        });
      });

    setQuestionList(questions);
  };

  const handelNextQuestion = () => {
    const nextQuestion = currentQuestion + 1;

    if (nextQuestion < questionList.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      setShowActive(true);
      history.push(`${localize.url}/resultat`);
    }
  };

  const handlePreviousQuestion = () => {
    const nextQuestion = currentQuestion - 1;

    if (nextQuestion < questionList.length && nextQuestion >= 0) {
      setCurrentQuestion(nextQuestion);
    } else {
      history.push(`${localize.url}/steg2`);
    }
  };

  useEffect(() => {
    createQuestionList();
  }, []);

  return (
    <div className='survey-content'>
      {survey && (
        <motion.div
          className='survey-content__container'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <h4>{`Fråga ${currentQuestion + 1} av ${questionList.length}`}</h4>
          <h2>{survey.questions[currentQuestion].question}</h2>
          <motion.div
            className='question-form'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <div className='radio-btns'>
              <label className='radio-btns__label'>
                <input
                  onChange={onChange}
                  name={`answer_${currentQuestion}`}
                  checked={
                    result && result[`answer_${currentQuestion}`] === '0'
                  }
                  type='radio'
                  value='0'
                />
                <span>Inte alls</span>
              </label>

              <label className='radio-btns__label'>
                <input
                  onChange={onChange}
                  name={`answer_${currentQuestion}`}
                  checked={
                    result && result[`answer_${currentQuestion}`] === '1'
                  }
                  type='radio'
                  value='1'
                />
                <span>Delvis</span>
              </label>
              <label className='radio-btns__label'>
                <input
                  onChange={onChange}
                  name={`answer_${currentQuestion}`}
                  checked={
                    result && result[`answer_${currentQuestion}`] === '2'
                  }
                  type='radio'
                  value='2'
                />
                <span>Helt</span>
              </label>
            </div>
            <div className='button-group'>
              <button onClick={handlePreviousQuestion} className='button'>
                Tillbaka
              </button>
              <button
                onClick={onsubmit}
                className='button'
                disabled={!result[`answer_${currentQuestion}`]}
              >
                Fortsätt
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
}
